export default "__VITE_ASSET__346e7e68__"